// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"618":"3e073bfb","924":"f9ce9b47","970":"cb4fa2b7"}[chunkId] + ".chunk.js";
};